import { Typography } from 'src/ui/common/atoms/typography';
import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
    background: ${({ theme }) => theme.colors.grey900};
`;

export const StyledContainer = styled.div`
    width: 100%;
    padding: 40px 16px;

    ${media.sm`
        padding 140px 20px 180px 20px;
        margin: 0 auto;
        max-width: 640px
    `}
`;

export const StyledTitleWrapper = styled.div`
    padding-bottom: 48px;
    color: ${({ theme }) => theme.colors.white};
    text-align: center;
    display: flex;

    & span {
        font-size: 26px;
        line-height: 28px;
        font-family: ${({ theme }) => theme.fonts.title};
        padding-right: 8px;

        ${media.sm`
            font-size: 40px;
            line-height: 48px;
        `}
    }
`;

export const StyledHighlightedText = styled(Typography)`
    font-size: 32px;
    text-align: center;

    ${media.sm`
       font-size: 44px;
    `}
`;

export const StyledFormWrapper = styled.div`
    padding: 0 6px;

    ${media.sm`
        padding: 0 40px;
    `}
`;